import React from 'react';
import './NeurocortexCards.css';
import { useLanguage } from '../contexts/LanguageContext';

const NeurocortexCards = () => {
  const { t } = useLanguage();
  
  const cards = [
    {
      icon: '/images/site-gorselleri-efektli/4.PNG',
      hoverIcon: '/images/site-gorselleri-efektli/4.2.png',
      titleKey: 'neurocortexCards.cards.0.title',
      descriptionKey: 'neurocortexCards.cards.0.description'
    },
    {
      icon: '/images/site-gorselleri-efektli/5.png',
      hoverIcon: '/images/site-gorselleri-efektli/5.2.png',
      titleKey: 'neurocortexCards.cards.1.title',
      descriptionKey: 'neurocortexCards.cards.1.description'
    },
    {
      icon: '/images/site-gorselleri-efektli/6.PNG',
      hoverIcon: '/images/site-gorselleri-efektli/6.2.PNG',
      titleKey: 'neurocortexCards.cards.2.title',
      descriptionKey: 'neurocortexCards.cards.2.description'
    }
  ];

  return (
    <section className="neurocortex-cards">
      <div className="container">
        <div className="cards-grid">
          {cards.map((card, index) => (
            <div key={index} className="card">
              <div className="card-icon">
                <img 
                  src={card.icon} 
                  alt={t(card.titleKey)}
                  className="card-icon-default"
                />
                <img 
                  src={card.hoverIcon} 
                  alt={t(card.titleKey)}
                  className="card-icon-hover"
                />
              </div>
              <h3 className="card-title">{t(card.titleKey)}</h3>
              <p className="card-description">{t(card.descriptionKey)}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default NeurocortexCards;
